import $visa from '@api/visa';
import { Toast, Indicator } from 'mint-ui';
const changeOptions = obj => {
  const res = Object.keys(obj).map(v => {
    return { label: v, value: obj[v] }
  });
  return res;
};
export default {
  $toast (message) {
    Toast({
      message,
      position: 'top',
      duration: 2000
    });
  },
  scrollTo (top = 0, DOM = window) {
    DOM.scrollTo({ top, behavior: "smooth" });
  },
  loading () {
    Indicator.open();
  },
  loadend () {
    Indicator.close();
  },
  // 获取当前用户的价格
  getPriceName () {
    const { userInfo } = this.$store.state;
    if ( !userInfo ) { return 'CustomerPrice'; }
    const { customerType } = userInfo;
    const names = {
      // 2: ['TradePrice', 'SmallCreditPaymen'],
      2: 'TradePrice', // 分销商
      4: 'CustomerPrice', // 直客
      16: 'BigCreditPayment' // 大客户
    };
    return names[customerType];
  },
  // 获取订单搜索参数
  getVisaOptions () {
    return new Promise(resolve => {
      const storageDataStr = localStorage.getItem('visaOptions');
      if ( storageDataStr ) {
        resolve(JSON.parse(storageDataStr));
        return;
      }
      $visa.getSearchData().then(data => {
        const {
          order_client_status,
          order_isPaid,
          order_refund_status,
          order_status,
          visaForm,
          visaKind
        } = data;
        let res = { visaForm, visaKind };
        res.clientStatus = changeOptions(order_client_status);
        res.isPaid = changeOptions(order_isPaid);
        res.refundStatus = changeOptions(order_refund_status);
        res.orderStatus = changeOptions(order_status);
        localStorage.setItem("visaOptions", JSON.stringify(res));
        resolve(res);
        // 转换数据
      })
    })
    
  },
  // 获取用户信息
  getUserInfo () {
    const store = this.$store.state.userInfo;
    if (store !== null) { return store; }
    const storage = JSON.parse(localStorage.getItem("userInfo") || null);
    if (storage !== null) { return storage; }
    return null;
  },
  // 更新userInfo, 支持单个参数
  updateUserInfo (user) {
    if (typeof user !== "object" || user === null) {
      // console.warn("[Update UserInfo Error] #参数有误！");
      localStorage.removeItem("userInfo");
      this.$store.commit('setUserInfo', null);
      return false;
    }
    const { userInfo: old } = this.$store.state;
    const userInfo = { ...old, ...user };
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    this.$store.commit('setUserInfo', userInfo);
  },
  // 清除用户信息
  clearUserInfo () {
    localStorage.removeItem('userInfo');
    this.$store.commit("setUserInfo", null);
  },
  // 倒计时
  startCountdown (attr, second = 60) {
    let codeTime = second; // 倒计时秒数
    this[attr] = codeTime;
    let tem = setInterval(() => {
      codeTime -= 1;
      if (codeTime === 0) {
        this[attr] = null;
        clearInterval(tem);
        return;
      }
      this[attr] = codeTime;
    }, 1000);
  },
  visCache () {
    return new Promise(resolve => {
      const visCache = JSON.parse(localStorage.getItem('visCache') || 'null');
      if ( visCache ) { resolve(visCache); return; }
      $visa.visCache().then(res => {
        localStorage.setItem('visCache', JSON.stringify(res));
        resolve(res);
      })
    })
  }
}